import {
  Checkbox as AntCheckbox,
  CheckboxProps as AntCheckboxProps
} from 'antd';
import './index.less';

type CheckboxProps = Omit<AntCheckboxProps, 'type'> & {
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'default';
};

export interface CheckboxRef {
  focus: (options?: FocusOptions) => void;
  blur: () => void;
  input: HTMLInputElement | null;
}

export const Checkbox = ({
  className = '',
  size = 'default',
  ...props
}: CheckboxProps) => {
  return (
    <AntCheckbox {...props} className={`${className} checkbox__${size}`} />
  );
};
